import Head from 'next/head';
import type { ReactElement } from 'react';

import { StandardLayout } from '@components/Layouts/StandardLayout';
import { Paragraph } from '@components/Typography/Paragraph/Paragraph';
import { TextLink } from '@components/Typography/TextLink/TextLink';

export default function PasswordResetRequestError() {
  return (
    <>
      <Head>
        <title>
          Password Reset Requested on the Bulk Nutrients Australia website
        </title>
        <meta
          name="title"
          content="Password Reset Requested on the Bulk Nutrients Australia website"
        />
        <meta
          name="description"
          content="Password Reset Requested at Bulk Nutrients, Australia's first choice for nutritional supplements."
        />
      </Head>
      <main
        id="main-content"
        className="min-h-auto dark:bg-none lg:min-h-[640px]"
      >
        <section className="mx-auto my-0 max-w-narrow-page p-2.5">
          <h1>Password Reset Request Error</h1>
          <Paragraph>Thanks for validating your email address.</Paragraph>
          <Paragraph>
            Unfortunately we had an issue sending you an email with instructions
            to reset your password.
          </Paragraph>
          <Paragraph>
            Please <TextLink href="/forgot-password">request it again</TextLink>{' '}
            or <TextLink href="/contact-us">get in touch</TextLink> with our
            Customer Service team.
          </Paragraph>
        </section>
      </main>
    </>
  );
}

PasswordResetRequestError.getLayout = function getLayout(page: ReactElement) {
  return <StandardLayout>{page}</StandardLayout>;
};
